import EntityIcon from '../../../../components/EntityIcon/EntityIcon';
import React from 'react';
import {Box, PreviewContainer, ResultSubject, Text} from '../../../../styled';
import HighlightMarker from '../../../../components/HighlightMarker/HighlightMarker';
import FileAttachments from '../../../../components/FileAttachments/FileAttachments';
import {getFileOwnership} from './FilesSnippet';


const FilesPreview = ({ item }: any) => {
  const files = [{ ...item }];
  const ownership = getFileOwnership(item);
  return (
    <Box display="flex" flexDirection="column" overflow="hidden" width="100%">
      <Box display="flex" alignItems="center">
        <Box mr={20}>
          <EntityIcon entityName={item.pl} />
        </Box>
        <Box>
          <ResultSubject>
            <HighlightMarker>{item.title}</HighlightMarker>
          </ResultSubject>
        </Box>
      </Box>
      <PreviewContainer
        display="flex" flexDirection="column"
        ml={[0, 60]} flex="1"
      >
        <FileAttachments files={files} />
        <Text variant="muted" size="small" >
          {ownership} | {item.date}
        </Text>
      </PreviewContainer>
    </Box>
  )
}

export default FilesPreview;